import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../../api/axios';
import './UserManagement.css';
import { FiSearch } from 'react-icons/fi';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CustomerDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [showEditModal, setShowEditModal] = useState(false);
  
const [enquiries, setEnquiries] = useState([]);
const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);
const [customerLoading, setCustomerLoading] = useState(false);
const [blockActionLoading, setBlockActionLoading] = useState(false);
const [formErrors, setFormErrors] = useState({});

useEffect(() => {
  fetchCustomerProfile();
}, [id]);


const fetchCustomerProfile = async () => {
  try {
    setCustomerLoading(true);

    const res = await api.get('/user/profile', {
      params: {
        user_id: id 
      }
    });

    const customer = res.data.data;

   setEditForm({
  name: customer?.name || '',
  email: customer?.email || '',
  phone: customer?.mobile_number || '',
  gender: customer?.gender || '',
  state: customer?.state || '',
  coins: customer?.coins || 0,
  roles: customer?.roles || [],
  status: customer?.status || '',
  customerProfileCompletion: customer?.customerProfileCompletion || 0
});

  } catch (error) {
    console.error('Failed to fetch customer profile', error);
  } finally {
    setCustomerLoading(false);
  }
}

const limit = 10;

const [editForm, setEditForm] = useState({
  name: '',
  email: '',
  phone: '',
  gender: '',
  state: '',
  coins: '',
  roles: [],
  status: '',
  customerProfileCompletion: 0
});

useEffect(() => {
    fetchEnquiries();
  }, [currentPage,searchTerm]);

  const fetchEnquiries = async () => {
    try {
      const res = await api.get('/admin/inquiry', {
        params: {
          user_id: id,                 
          page: currentPage,
          limit,
          createdByRole: 'customer',
           search: searchTerm
        }
      });

      setEnquiries(res.data.data || []);
      setTotalPages(res.data.pagination?.totalPages || 1);
    } catch (error) {
      console.error('Failed to fetch enquiries', error);
    }
}


  const handleBack = () => {
    navigate('/user-management');
  };

  const handleEdit = () => {
    setFormErrors({});
    setShowEditModal(true);
  };

  const handleSave = async () => {
    const errors = {};
    if (!editForm.name?.trim()) errors.name = "Name is required";
    if (!editForm.email?.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(editForm.email)) {
      errors.email = "Invalid email format";
    }
    if (!editForm.phone?.trim()) {
      errors.phone = "Mobile number is required";
    } else if (!/^\d{10}$/.test(editForm.phone)) {
      errors.phone = "Mobile number must be 10 digits";
    }
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    try {
      await api.put(`/admin/update/user/${id}`, {
        name: editForm.name,
        email: editForm.email,
        mobile_number: editForm.phone,
      });
      toast.success("Customer updated successfully");
      setFormErrors({});
      setShowEditModal(false);
      fetchCustomerProfile();
    } catch (err) {
      console.error("Error updating customer", err);
      if (err?.response?.status === 409) {
        setFormErrors({ email: "Email already exists" });
        return;
      }
      toast.error(err?.response?.data?.message || "Failed to update customer");
    }
  };

  const isCustomerBlocked = ["inactive", "blocked"].includes(
    (editForm?.status || "").toLowerCase()
  );

  const handleToggleBlockStatus = async () => {
    try {
      setBlockActionLoading(true);
      if (isCustomerBlocked) {
        await api.put(`/admin/reactivate/user/${id}`);
        toast.success("Customer unblocked successfully");
      } else {
        await api.put(`/admin/soft-delete/user/${id}`, {
          reason: "inactive",
        });
        toast.success("Customer blocked successfully");
      }
      await fetchCustomerProfile();
    } catch (error) {
      console.error("Block/unblock failed", error);
      toast.error(error?.response?.data?.message || "Block/unblock failed");
    } finally {
      setBlockActionLoading(false);
    }
  };

  

  // Sample enquiries data
  // const enquiries = [
  //   {
  //     id: 1,
  //     vendorName: 'Suraj Kumar',
  //     phone: '+91 8302923800',
  //     eventLocation: 'Delhi',
  //     email: 'Suraj@gmail.com',
  //     servicesRequested: 'DJ, Catering',
  //     eventDate: '12/10/2025',
  //     status: 'Pending'
  //   }
  // ];

  // const filteredEnquiries = enquiries.filter(enquiry =>
  //   enquiry.vendorName.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //   enquiry.eventLocation.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //   enquiry.servicesRequested.toLowerCase().includes(searchTerm.toLowerCase())
  // );

  return (
    <div className="customer-details">
      {customerLoading && (
      <div className="loading-text">Loading customer details...</div>
    )}
      <div className="details-header">
        <button className="back-btn" onClick={handleBack}>
          ← Back
        </button>
        <div className="header-actions">
          <h1>👤Customer Details</h1>
          <button className="edit-btn" onClick={handleEdit}>Edit</button>
          <button
            className="edit-btn"
            onClick={handleToggleBlockStatus}
            disabled={blockActionLoading}
          >
            {blockActionLoading
              ? "Please wait..."
              : isCustomerBlocked
              ? "Unblock Customer"
              : "Block Customer"}
          </button>
        </div>
      </div>

      {/* Customer Info Card */}
      <div className="customer-info-card">
  <div className="customer-name">
    <span className="label">Customer Name</span>
    <span className="value">
      {editForm?.name
        ? editForm.name.charAt(0).toUpperCase() + editForm.name.slice(1)
        : 'N/A'}
    </span>
  </div>
  
  <div className="customer-details-grid">
    <div className="detail-item">
      <span className="label">Email</span>
      <span className="value">
        {editForm?.email?.trim() || 'N/A'}
      </span>
    </div>

<div className="detail-item">
  <span className="label">Roles</span>
  <span className="value">
    {editForm?.roles?.length
      ? editForm.roles
          .map(role =>
            role.userType.charAt(0).toUpperCase() +
            role.userType.slice(1)
          )
          .join(', ')
      : 'N/A'}
  </span>
</div>

    <div className="detail-item">
      <span className="label">Phone</span>
      <span className="value">
        {editForm?.phone?.trim() || 'N/A'}
      </span>
    </div>
    <div className="detail-item">
  <span className="label">Gender</span>
  <span className="value">
    {editForm?.gender?.trim() || 'N/A'}
  </span>
</div>

   <div className="profile-completion">
  <div className="label">
    Profile Completion: {editForm.customerProfileCompletion}%
  </div>

  <div className="progress-bar">
    <div
      className="progress-fill"
      style={{ width: `${editForm.customerProfileCompletion}%` }}
    />
  </div>
</div>

    <div className="detail-item">
      <span className="label">State</span>
      <span className="value">
        {editForm?.state?.trim() || 'N/A'}
      </span>
    </div>
  </div>
  
  
  <div className="coins-section">
    <span className="label">Coins</span>
    <span className="coins-value">
      {editForm?.coins !== undefined && editForm?.coins !== null
        ? editForm.coins
        : '0'}
    </span>
  </div>

  
</div>


      {/* Enquiries Section */}
      <div className="enquiries-section">
        <div className="enquiries-header">
          <h3>Enquiries</h3>
          <div className="enquiries-actions">
            <div className="search-box">
              <span className="search-icon"><FiSearch /></span>
              <input
                type="text"
                placeholder="Search"
                value={searchTerm}
                onChange={(e) => { 
                  setSearchTerm(e.target.value)
                  setCurrentPage(1)
                }
                }
              />
            </div>
            {/* <button className="filter-btn">⚙️</button> */}
          </div>
        </div>

        <div className="enquiries-table">
          <div className="table-header">
            <span>Vendor Name</span>
            <span>Phone Number</span>
            <span>Event Location</span>
            <span>Email</span>
            <span>Services Requested</span>
            <span>Event Date</span>
            <span>Status</span>
          </div>
          {/* {filteredEnquiries.map((enquiry) => (
            <div key={enquiry.id} className="table-row">
              <span>{enquiry.vendorName}</span>
              <span>{enquiry.phone}</span>
              <span>{enquiry.eventLocation}</span>
              <span>{enquiry.email}</span>
              <span>{enquiry.servicesRequested}</span>
              <span>{enquiry.eventDate}</span>
              <span className={`status ${enquiry.status.toLowerCase()}`}>
                {enquiry.status}
              </span>
            </div>
          ))} */}
           {enquiries.length === 0 && (
            <div className="table-row">
              <span colSpan="7">No enquiries found</span>
            </div>
          )}
          {enquiries.map((enquiry) => (
            <div key={enquiry._id} className="table-row">
              <span>{enquiry.vendor?.name || 'N/A'}</span>
              <span>{enquiry.vendor?.mobile_number || 'N/A'}</span>
              <span>{enquiry.vendor?.shop_location || 'N/A'}</span>
              <span>{enquiry.vendor?.email || 'N/A'}</span>
              <span>{enquiry.services?.join(', ')}</span>
              <span>
                {new Date(enquiry.eventDate).toLocaleDateString()}
              </span>
              <span className={`status ${enquiry.status}`}>
                {enquiry.status}
              </span>
            </div>
          ))}
        </div>

       <div className="pagination">
          <button
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(prev => prev - 1)}
          >
            Prev
          </button>

          <span>
            Page {currentPage} of {totalPages}
          </span>

          <button
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(prev => prev + 1)}
          >
            Next
          </button>
        </div>
      </div>

      {/* Edit Modal */}
      {showEditModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Edit Customer Details</h2>
            <form className="customer-form">
             <div className="form-row">
  <div className="form-group">
    <label>Phone</label>
    <input
      type="tel"
      value={editForm.phone}
      onChange={(e) =>
        setEditForm({
          ...editForm,
          phone: e.target.value
            .replace(/\D/g, '')
            .slice(0, 10)
        })
      }
    />
    {formErrors.phone && (
      <span className="form-error">
        {formErrors.phone}
      </span>
    )}
  </div>

  <div className="form-group">
    <label>Gender</label>

    <select
      value={editForm.gender}
      onChange={(e) =>
        setEditForm({
          ...editForm,
          gender: e.target.value
        })
      }
    >
      <option value="">Select Gender</option>
      <option value="Male">Male</option>
      <option value="Female">Female</option>
      <option value="Other">Other</option>
    </select>
  </div>
</div>

<div className="form-row">
  <div className="form-group">
    <label>State</label>

    <input
      type="text"
      value={editForm.state}
      onChange={(e) =>
        setEditForm({
          ...editForm,
          state: e.target.value
            .replace(/[^A-Za-z ]/g, '')
            .slice(0, 50)
        })
      }
    />
  </div>
</div>
              <div className="form-row">
                <div className="form-group">
                  <label>Phone</label>
                  <input
                    type="tel"
                    value={editForm.phone}
                    onChange={(e) => setEditForm({...editForm, phone: e.target.value})}
                  />
                  {formErrors.phone && <span className="form-error">{formErrors.phone}</span>}
                </div>
                {/* <div className="form-group">
                  <label>Gender</label>
                  <select
                    value={editForm.gender}
                    onChange={(e) => setEditForm({...editForm, gender: e.target.value})}
                  >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                  </select>
                </div> */}
              </div>
              <div className="form-actions">
                <button type="button" className="cancel-btn" onClick={() => setShowEditModal(false)}>
                  Cancel
                </button>
                <button type="button" className="done-btn" onClick={handleSave}>
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <ToastContainer
        toastClassName="custom-toast"
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default CustomerDetails;